import { render } from "./help-dialog-project-id.vue?vue&type=template&id=11e0e5b2"
import script from "./help-dialog-project-id.vue?vue&type=script&setup=true&lang=js"
export * from "./help-dialog-project-id.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/noon/help-dialog-project-id.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11e0e5b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11e0e5b2', __exports__)) {
    console.log('reload')
    api.reload('11e0e5b2', __exports__)
  }
  
  module.hot.accept("./help-dialog-project-id.vue?vue&type=template&id=11e0e5b2", () => {
    console.log('re-render')
    api.rerender('11e0e5b2', render)
  })

}


export default __exports__